/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:integration_id/fetch_collections" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyFetchCollections } from "./constants";
import type { GetAlloysPartnersShopifyFetchCollectionsResult } from "./types";
import { isGetAlloysPartnersShopifyFetchCollectionsResult } from "./validators";

export const getAlloysPartnersShopifyFetchCollections = reactQueryFetcherAdapter(
  alloysPartnersShopifyFetchCollections,
  (signal: AbortSignal, integrationId: string): Promise<GetAlloysPartnersShopifyFetchCollectionsResult> => {
    return fetch(`/alloys/partners/shopify/${integrationId}/fetch_collections`, "GET", {}, { signal });
  },
  isGetAlloysPartnersShopifyFetchCollectionsResult
);
